// The app no longer ships a service worker. This removes one left behind by
// older builds, along with its caches, so returning visitors get fresh assets.
export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister()

        if (caches) {
          // Service worker cache should be cleared with caches.delete()
          caches.keys().then(async (names) => {
            await Promise.all(names.map((name) => caches.delete(name)))
          })
        }
      })
      .catch((error) => {
        console.error(error.message)
      })
  }
}
